import React from "react";
import PropTypes from "prop-types";
//
import MuiAvatar from "@mui/material/Avatar";
const Chip = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiAvatar, rest, children);
};
Chip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default Chip;